import React from 'react'

import { Box, Button, Snackbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  notificationRoot: {
    right: 0,
    bottom: 0,
    width: '100%',
  },
  constrainedWidth: {
    maxWidth: theme.breakpoints.values.lg,
    padding: `0 ${theme.spacing(1)}px`,
    [theme.breakpoints.only('sm')]: {
      padding: `0 ${theme.spacing(6)}px`,
    },
    [theme.breakpoints.only('md')]: {
      padding: `0 ${theme.spacing(8)}px`,
    },
    [theme.breakpoints.up('lg')]: {
      padding: `0 ${theme.spacing(3)}px`,
    },
  },
  notificationContainer: {
    width: '100%',
  },
}))

const MessageCreatedNotification = ({ onDismiss, show, fullWidth }) => {
  const classes = useStyles()

  return (
    <Snackbar
      className={`${classes.notificationRoot} ${fullWidth ? '' : classes.constrainedWidth}`}
      open={show}
      onClose={onDismiss}
    >
      <Alert
        severity="success"
        className={classes.notificationContainer}
        onClose={onDismiss}
      >
        <Box>You have successfully created a Message.</Box>
        <Button
          color="primary"
          component={Link}
          to={`${import.meta.env.BASE_URL}/engage/messaging`}
        >
          View Message
        </Button>
      </Alert>
    </Snackbar>
  )
}
MessageCreatedNotification.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  show: PropTypes.bool,
  fullWidth: PropTypes.bool,
}

MessageCreatedNotification.defaultProps = {
  fullWidth: true,
}

export default MessageCreatedNotification
